import { render, staticRenderFns } from "./ConsentsAndRegulations.vue?vue&type=template&id=ab67c032&scoped=true&"
import script from "./ConsentsAndRegulations.vue?vue&type=script&lang=js&"
export * from "./ConsentsAndRegulations.vue?vue&type=script&lang=js&"
import style0 from "./ConsentsAndRegulations.vue?vue&type=style&index=0&id=ab67c032&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab67c032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VContainer,VList,VListItem,VListItemContent,VRow,VSwitch})
